import * as React from "react";
import type { SVGProps } from "react";
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.228 4.145a.55.55 0 0 1 .723 0c.199.18.199.475 0 .656l-5.729 5.207 5.729 5.208c.199.181.199.475 0 .656a.55.55 0 0 1-.723 0L11.5 10.664l-5.728 5.208a.55.55 0 0 1-.723 0 .435.435 0 0 1 0-.656l5.728-5.208L5.049 4.8a.435.435 0 0 1 0-.656.55.55 0 0 1 .723 0L11.5 9.352z"
    />
  </svg>
);
export default SvgCross;
